export interface ArticleCard {
  slug: string;
  titleKey: string;
  descKey: string;
  imageUrl: string;
  readTime: number;
  lastUpdated: string;
  href: string;
}

export const articleCards: ArticleCard[] = [
  {
    slug: 'cssbuy-spreadsheet-guide',
    titleKey: 'articles.article1Title',
    descKey: 'articles.article1Desc',
    imageUrl: 'https://readdy.ai/api/search-image?query=Organized%20product%20research%20workspace%20with%20sneakers%20hoodies%20and%20accessories%20arranged%20in%20a%20grid%20on%20a%20warm%20wooden%20desk%2C%20laptop%20showing%20a%20spreadsheet%20with%20product%20links%2C%20soft%20natural%20window%20light%2C%20warm%20neutral%20beige%20and%20cream%20tones%2C%20editorial%20fashion%20and%20tech%20photography%2C%20high%20detail%2C%20clean%20composition&width=800&height=600&seq=art1-card&orientation=landscape',
    readTime: 8,
    lastUpdated: '2026-08-26',
    href: '/pt/articles/cssbuy-spreadsheet-guide',
  },
  {
    slug: 'cssbuy-shipping-cost',
    titleKey: 'articles.article2Title',
    descKey: 'articles.article2Desc',
    imageUrl: 'https://readdy.ai/api/search-image?query=International%20shipping%20logistics%20with%20cardboard%20parcels%20and%20a%20measuring%20tape%20on%20a%20clean%20desk%2C%20world%20map%20in%20soft%20neutral%20tones%20on%20the%20wall%2C%20natural%20light%2C%20warm%20beige%20and%20cream%20palette%2C%20editorial%20product%20photography%2C%20detailed%20and%20organized&width=800&height=600&seq=art2-card&orientation=landscape',
    readTime: 6,
    lastUpdated: '2026-08-26',
    href: '/pt/articles/cssbuy-shipping-cost',
  },
  {
    slug: 'cssbuy-legit-safety',
    titleKey: 'articles.article3Title',
    descKey: 'articles.article3Desc',
    imageUrl: 'https://readdy.ai/api/search-image?query=Security%20and%20trust%20concept%20with%20a%20shield%20icon%20made%20of%20soft%20materials%20and%20a%20padlock%20next%20to%20fashion%20items%20on%20a%20clean%20desk%2C%20warm%20neutral%20beige%20background%2C%20natural%20light%2C%20editorial%20product%20photography%2C%20calm%20and%20reassuring%20mood%2C%20high%20detail&width=800&height=600&seq=art3-card&orientation=landscape',
    readTime: 5,
    lastUpdated: '2026-08-26',
    href: '/pt/articles/cssbuy-legit-safety',
  },
  {
    slug: 'cssbuy-coupon-guide',
    titleKey: 'articles.article4Title',
    descKey: 'articles.article4Desc',
    imageUrl: 'https://readdy.ai/api/search-image?query=Discount%20coupon%20and%20shopping%20tags%20arranged%20with%20a%20small%20calculator%20and%20fashion%20accessories%20on%20a%20warm%20desk%2C%20soft%20natural%20light%2C%20beige%20and%20cream%20tones%2C%20editorial%20product%20photography%2C%20clean%20and%20organized%20composition%2C%20inviting%20mood&width=800&height=600&seq=art4-card&orientation=landscape',
    readTime: 4,
    lastUpdated: '2026-08-26',
    href: '/pt/articles/cssbuy-coupon-guide',
  },
  {
    slug: 'cssbuy-warehouse-guide',
    titleKey: 'articles.article5Title',
    descKey: 'articles.article5Desc',
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20warehouse%20interior%20with%20neatly%20stacked%20cardboard%20boxes%20and%20a%20scanning%20station%2C%20warm%20industrial%20lighting%2C%20beige%20and%20cream%20tones%2C%20editorial%20logistics%20photography%2C%20clean%20and%20organized%2C%20high%20detail%2C%20calm%20atmosphere&width=800&height=600&seq=art5-card&orientation=landscape',
    readTime: 7,
    lastUpdated: '2026-08-26',
    href: '/pt/articles/cssbuy-warehouse-guide',
  },
  {
    slug: 'cssbuy-qc-guide',
    titleKey: 'articles.article6Title',
    descKey: 'articles.article6Desc',
    imageUrl: 'https://readdy.ai/api/search-image?query=Quality%20control%20inspection%20of%20sneakers%20with%20a%20magnifying%20glass%20and%20camera%20on%20a%20clean%20desk%2C%20warm%20natural%20light%2C%20beige%20and%20cream%20tones%2C%20editorial%20product%20photography%2C%20detail%20focused%20composition%2C%20professional%20and%20organized&width=800&height=600&seq=art6-card&orientation=landscape',
    readTime: 6,
    lastUpdated: '2026-08-26',
    href: '/pt/articles/cssbuy-qc-guide',
  },
  {
    slug: 'cssbuy-w2c-spreadsheet',
    titleKey: 'articles.article7Title',
    descKey: 'articles.article7Desc',
    imageUrl: 'https://readdy.ai/api/search-image?query=Product%20link%20discovery%20concept%20with%20a%20smartphone%20showing%20shopping%20links%20and%20sneakers%20on%20a%20clean%20desk%2C%20warm%20natural%20light%2C%20beige%20and%20cream%20palette%2C%20editorial%20tech%20and%20fashion%20photography%2C%20organized%20and%20detailed&width=800&height=600&seq=art7-card&orientation=landscape',
    readTime: 7,
    lastUpdated: '2026-08-26',
    href: '/pt/articles/cssbuy-w2c-spreadsheet',
  },
  {
    slug: 'cssbuy-alternatives',
    titleKey: 'articles.article8Title',
    descKey: 'articles.article8Desc',
    imageUrl: 'https://readdy.ai/api/search-image?query=Comparison%20concept%20with%20two%20stacks%20of%20documents%20and%20a%20scale%20balance%20next%20to%20fashion%20items%20on%20a%20clean%20desk%2C%20warm%20natural%20light%2C%20beige%20and%20cream%20tones%2C%20editorial%20product%20photography%2C%20balanced%20and%20organized%20composition&width=800&height=600&seq=art8-card&orientation=landscape',
    readTime: 6,
    lastUpdated: '2026-08-26',
    href: '/pt/articles/cssbuy-alternatives',
  },
  {
    slug: 'cssbuy-shipping-brazil',
    titleKey: 'articles.article9Title',
    descKey: 'articles.article9Desc',
    imageUrl: 'https://readdy.ai/api/search-image?query=Shipping%20to%20Brazil%20concept%20with%20a%20cardboard%20box%20and%20Brazilian%20flag%20colors%20subtly%20in%20soft%20accessories%2C%20warm%20natural%20light%2C%20beige%20and%20cream%20palette%2C%20editorial%20logistics%20photography%2C%20organized%20and%20clean%20composition&width=800&height=600&seq=art9-card&orientation=landscape',
    readTime: 6,
    lastUpdated: '2026-08-26',
    href: '/pt/articles/cssbuy-shipping-brazil',
  },
  {
    slug: 'cssbuy-seller-verification',
    titleKey: 'articles.article10Title',
    descKey: 'articles.article10Desc',
    imageUrl: 'https://readdy.ai/api/search-image?query=Seller%20verification%20concept%20with%20a%20storefront%20icon%20and%20checklist%20on%20a%20clean%20desk%20with%20fashion%20accessories%2C%20warm%20natural%20light%2C%20beige%20and%20cream%20tones%2C%20editorial%20product%20photography%2C%20trust%20and%20security%20mood&width=800&height=600&seq=art10-card&orientation=landscape',
    readTime: 5,
    lastUpdated: '2026-08-26',
    href: '/pt/articles/cssbuy-seller-verification',
  },
  {
    slug: 'cssbuy-parcel-consolidation',
    titleKey: 'articles.article11Title',
    descKey: 'articles.article11Desc',
    imageUrl: 'https://readdy.ai/api/search-image?query=Parcel%20consolidation%20concept%20with%20multiple%20small%20boxes%20being%20combined%20into%20one%20larger%20box%20on%20a%20clean%20desk%2C%20warm%20natural%20light%2C%20beige%20and%20cream%20tones%2C%20editorial%20logistics%20photography%2C%20organized%20and%20efficient&width=800&height=600&seq=art11-card&orientation=landscape',
    readTime: 5,
    lastUpdated: '2026-08-26',
    href: '/pt/articles/cssbuy-parcel-consolidation',
  },
  {
    slug: 'cssbuy-beginner-handbook',
    titleKey: 'articles.article12Title',
    descKey: 'articles.article12Desc',
    imageUrl: 'https://readdy.ai/api/search-image?query=Beginner%20shopping%20guide%20concept%20with%20an%20open%20notebook%2C%20pen%20and%20fashion%20items%20on%20a%20warm%20desk%2C%20soft%20natural%20light%2C%20beige%20and%20cream%20tones%2C%20editorial%20product%20photography%2C%20welcoming%20and%20educational%20mood&width=800&height=600&seq=art12-card&orientation=landscape',
    readTime: 9,
    lastUpdated: '2026-08-26',
    href: '/pt/articles/cssbuy-beginner-handbook',
  },
  {
    slug: 'cssbuy-product-research',
    titleKey: 'articles.article13Title',
    descKey: 'articles.article13Desc',
    imageUrl: 'https://readdy.ai/api/search-image?query=Product%20research%20concept%20with%20a%20laptop%20showing%20search%20results%20and%20fashion%20items%20spread%20on%20a%20desk%2C%20warm%20natural%20light%2C%20beige%20and%20cream%20tones%2C%20editorial%20tech%20and%20fashion%20photography%2C%20detailed%20and%20organized&width=800&height=600&seq=art13-card&orientation=landscape',
    readTime: 7,
    lastUpdated: '2026-08-26',
    href: '/pt/articles/cssbuy-product-research',
  },
  {
    slug: 'cssbuy-sneakers-spreadsheet',
    titleKey: 'articles.article14Title',
    descKey: 'articles.article14Desc',
    imageUrl: 'https://readdy.ai/api/search-image?query=Collection%20of%20stylish%20sneakers%20arranged%20in%20a%20row%20on%20a%20clean%20surface%2C%20warm%20natural%20light%2C%20beige%20and%20cream%20tones%2C%20editorial%20product%20photography%2C%20detailed%20texture%20and%20color%2C%20organized%20composition&width=800&height=600&seq=art14-card&orientation=landscape',
    readTime: 6,
    lastUpdated: '2026-08-26',
    href: '/pt/articles/cssbuy-sneakers-spreadsheet',
  },
];